<div class="page-content" *ngIf="state === 'SUCCESS'">
    <app-user-details-page *ngIf="pageType == PageType.USER" [user]="user"></app-user-details-page>
    <app-catalog-details
        (onCatalogUpdate)="updateCatalog($event)"
        *ngIf="pageType == PageType.CATALOG"
        [catalog]="catalog"
    ></app-catalog-details>
    <app-builder-io
        *ngIf="pageType == PageType.BUILDER_IO_TEMPLATE"
        [apiKey]="builderIOApiKey"
        [entry]="builderIOPageEntry"
    >
        <div class="container">Failed to load page</div>
    </app-builder-io>
    <div class="d-flex justify-content-center text-dark-gray" *ngIf="pageType == PageType.UNKNOWN">
        This catalog could not be found, or you do not have access to it.
    </div>
</div>
<div class="dpm-no-data text-dark-gray" *ngIf="state === 'ERROR'">There was a problem loading the page.</div>
<div *ngIf="state === 'LOADING'">
    <mat-spinner [diameter]="60"></mat-spinner>
</div>
